import React from 'react'
import PropTypes from 'prop-types'

const IconCaretSelect = ({ color = 'currentColor', ...props }) => (
  <svg height={12} viewBox="0 0 16 8" width={16} {...props}>
    <title>{'accordion icon'}</title>
    <path
      d="M6.89 9.376a1.565 1.565 0 002.114.096l.106-.097c.046-.046.089-.094.128-.144l.045-.044 6.063-6.063a1.596 1.596 0 000-2.263 1.602 1.602 0 00-2.262 0L7.95 5.995 2.844.89a1.566 1.566 0 00-2.22 0 1.566 1.566 0 000 2.22l6.267 6.267z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
)

IconCaretSelect.propTypes = {
  color: PropTypes.string,
}

export default IconCaretSelect
